import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.scss";
import Home from "./Components/Home";
import Read from "./Components/Read";

function App() {
    return (
        <Router>
            <div className="App">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/page/:pageNumber" element={<Read />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
